import React from 'react';
import { CardProps, CardType } from './Card/Card.props';
import {
  CardView,
  CardHeader,
  CardContent,
  CardFooter,
} from './Card/Card.view';
import { useMergedDesignSystemComponentProps } from 'src/design-system';
// This file defines and exports the main `Card` component, which serves as a wrapper for its sub-components like `Card.Header`, `Card.Content`, and `Card.Footer`, enabling a compound component pattern for flexible content structuring.
const CardComponent: React.FC<CardProps> = (props) => {
  const mergedProps = useMergedDesignSystemComponentProps('card', props);
  return <CardView {...mergedProps} />;
};
export const Card = CardComponent as CardType;
Card.Header = CardHeader;
Card.Content = CardContent;
Card.Footer = CardFooter;
